export default __webpack_public_path__ + "static/media/tutorCounter.494d0b0f.svg";